import { render, staticRenderFns } from "./DescriptionPanel.vue?vue&type=template&id=ce679abe&"
import script from "./DescriptionPanel.vue?vue&type=script&lang=js&"
export * from "./DescriptionPanel.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionPanel.vue?vue&type=style&index=0&id=ce679abe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports